import { Component, OnInit } from '@angular/core';
import { StyleManager } from '../shared/style-manager';

@Component({
  selector: 'itfg-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
})
export class AuthComponent implements OnInit {

  constructor(
  ) {
  }

  ngOnInit(): void {
  }

}
